const routes = [{
        path: '/',
        name: 'Dashboard',
        component: () =>
            import ('./views/Dashboard.vue'),
        meta: {
            title: 'BN Artwork Tool'
        }
    },
    {
        path: '/finder',
        name: 'finder',
        component: () =>
            import ('./views/Finder.vue'),
        meta: {
            title: 'Finder'
        }
    },
    {
        path: '/myartworks',
        name: 'myartworks',
        component: () =>
            import ('./views/Myartworks.vue'),
        meta: {
            title: 'My Artworks'
        }
    },
    {
        path: '/artwork/:aid',
        name: 'artwork',
        component: () =>
            import ('./views/Artwork.vue'),
        meta: {
            title: 'My Artworks'
        }
    },
    {
        path: '/about',
        name: 'about',
        component: () =>
            import ('./views/About.vue'),
        meta: {
            title: 'My Artworks'
        }
    },
    {
        path: '/myprojects',
        name: 'myprojects',
        component: () =>
            import ('./views/Myprojects.vue'),
        meta: {
            title: 'My Projects'
        }
    },
    {
        path: '/project/:id',
        name: 'project',
        component: () =>
            import ('./views/Project.vue'),
        meta: {
            title: 'My Projects'
        }
    },
    {
        path: '/roomtype/:rid/',
        name: 'roomtype',
        component: () =>
            import ('./views/Roomtype.vue'),
        meta: {
            title: 'My Roomtypes'
        }
    },
    {
        path: '/addproduct-keypad/:rid/',
        name: 'addproduct-keypad',
        component: () =>
            import ('./views/Addproduct-EA.vue'),
        meta: {
            title: 'Add a New Product'
        }
    },
    {
        path: '/addproduct-accessories/:rid/',
        name: 'addproduct-accessories',
        component: () =>
            import ('./views/Addproduct-ACC.vue'),
        meta: {
            title: 'Add Accessories'
        }
    },
    {
        path: '/addproduct-sockets/:id/',
        name: 'addproduct-sockets',
        component: () =>
            import ('./views/Addproduct-SK.vue'),
        meta: {
            title: 'Add a New Product'
        }
    },
    {
        path: '/addtoproject/:aid/',
        name: 'addtoproject',
        component: () =>
            import ('./views/AddToProject.vue'),
        meta: {
            title: 'Add To Project'
        }
    },
    {
        path: '/dashboard/',
        name: 'dashboard',
        component: () =>
            import ('./views/Dashboard.vue'),
        meta: {
            title: 'Dashboard'
        }
    },
    {
        path: '/myusers',
        name: 'myusers',
        component: () =>
            import ('./views/Myusers.vue'),
        meta: {
            title: 'User Management Panel'
        }
    },
    {
        path: '/user/:id',
        name: 'user',
        component: () =>
            import ('./views/User.vue'),
        meta: {
            title: 'User Profile'
        }
    },

    {
        path: '/collection/',
        name: 'collection',
        component: () =>
            import ('./views/configurator/collection.vue'),
        meta: {
            title: 'BN Artwork Tool'
        }
    },
    {
        path: '/account/:id',
        name: 'account',
        component: () =>
            import ('./views/Account.vue'),
        meta: {
            title: 'My Account'
        }
    },
  
    
    {//**********config ******/
        path: '/collection/config/:aid?',
        name: 'collection-config',
        component: () =>
            import ('./views/configurator/Config.vue'),
        meta: {
            title: 'Artwork Tool - Frame Color'
        }
    },
      {//**********format ******/
        path: '/collection/format/:aid?',
        name: 'collection-format',
        component: () =>
            import ('./views/configurator/Format.vue'),
        meta: {
            title: 'Artwork Tool - Format'
        }
    },
      {//**********button format ******/
        path: '/collection/button-format/:aid?',
        name: 'collection-button-format',
        component: () =>
            import ('./views/configurator/ButtonFormat.vue'),
        meta: {
            title: 'Artwork Tool - Button Format'
        }
    },
    {//**********product ******/
        path: '/collection/product/:aid?',
        name: 'collection-product',
        component: () =>
            import ('./views/configurator/Product.vue'),
        meta: {
            title: 'Artwork Tool - Product'
        }
    },
     {//**********style ******/
        path: '/collection/style/:aid?',
        name: 'collection-style',
        component: () =>
            import ('./views/configurator/Style.vue'),
        meta: {
            title: 'Artwork Tool - Style'
        }
    },

    {
        path: '/collection/engraving/:aid?',
        name: 'collection-engraving',
        component: () =>
            import ('./views/configurator/Engraving.vue'),
        meta: {
            title: 'Artwork Tool - Engraving'
        }
    },

    {
        path: '/collection/configuration/:aid?',
        name: 'collection-configuration',
        component: () =>
            import ('./views/configurator/Configuration.vue'),
        meta: {
            title: 'Artwork Tool - Configuration'
        }
    },

    {
        path: '/collection/preview/:aid?',
        name: 'collection-preview',
        component: () =>
            import ('./views/configurator/Preview.vue'),
        meta: {
            title: 'Artwork Tool - Preview'
        }
    },
    {
        path: '/collection/complete/:aid?',
        name: 'collection-complete',
        component: () =>
            import ('./views/configurator/Complete.vue'),
        meta: {
            title: 'Artwork Tool - Complete'
        }
    },
    
    {//others
        path: '/pdfPreview/:aid/:project?/:roomtype?/:qty?',
        name: 'pdf-preview',
        component: () =>
            import ('./views/configurator/PDFPreview.vue'),
        meta: {
            title: 'Artwork Tool - PDF Preview'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('./views/Login.vue'),
        meta: {
            title: 'Login'
        }
    },
    {
        path: '/signup',
        name: 'signup',
        component: () =>
            import ('./views/Signup.vue'),
        meta: {
            title: 'Sign Up'
        }
    },
    {
        path: '/password',
        name: 'password',
        component: () =>
            import ('./views/Password.vue'),
        meta: {
            title: 'Reset My Password'
        }
    },
    {
        path: '/news',
        name: 'news',
        component: () =>
            import ('./views/News.vue'),
        meta: {
            title: 'News'
        }
    },
    {
        path: '/post',
        name: 'post',
        props: true,
        component: () =>
            import ('./views/NewsPost.vue'),
        meta: {
            title: 'News Post'
        }
    },
    {
        path: '/newpost',
        name: 'newpost',
        props: true,
        component: () =>
            import ('./views/NewPost.vue'),
        meta: {
            title: 'Post'
        }
    },
    {
        path: '/managernews',
        name: 'managernews',
        component: () =>
            import ('./views/ManagerNews.vue'),
        meta: {
            title: 'Manager News'
        }
    },
    {
        path: '/technical-support',
        name: 'technical-support',
        component: () =>
            import ('./views/TechnicalSupport.vue'),
        meta: {
            title: 'Technical Resources'
        }
    },
    {
        path: '/technical-support/resources',
        name: 'technical-resources',
        component: () =>
            import ('./views/TechnicalResources.vue'),
        meta: {
            title: 'Technical Resources'
        }
    },
    {
        path: '/sales-resources',
        name: 'sales-resources',
        component: () =>
            import ('./views/SalesResources.vue'),
        meta: {
            title: 'Sales Resources'
        }
    },
    {
        path: '/sales-resources/manage',
        name: 'sales-resources-manage',
        component: () =>
            import ('./views/ManageSalesResources.vue'),
        meta: {
            title: 'Manage Sales Resources'
        }
    },
    {
        path: '/technical-support/resources/manage',
        name: 'technical-resources-manage',
        component: () =>
            import ('./views/ManageTechnicalResources.vue'),
        meta: {
            title: 'Manage Technical Resources'
        }
    },
    {
        path: '/technical-support/resources/manage/tech',
        name: 'technical-resources-manage-tech',
        props: true,
        component: () =>
            import ('./views/TechnicalResourcesDocu.vue'),
        meta: {
            title: 'Manage Technical Resources'
        }
    },
    {
        path: '/sales-resources/manage/tech',
        name: 'sales-resources-manage-tech',
        props: true,
        component: () =>
            import ('./views/SalesResourcesDocu.vue'),
        meta: {
            title: 'Manage Sales Resources'
        }
    },
    {
        path: '/salespipeline',
        name: 'salespipeline',
        component: () =>
            import ('./views/SalesPipeline.vue'),
        meta: {
            title: 'Sales Pipeline'
        }
    },
  
]

export default routes